import { Link } from "react-router-dom";
import { ArrowRight, ExternalLink } from "lucide-react";
import { PageHero } from "../components/site/PageHero";
import { SectionLabel } from "../components/site/SectionLabel";
import { CTASection } from "../components/site/CTASection";
import { SIL_RESOURCES } from "../data/technical";

export default function TechnicalResources() {
  return (
    <div>
      <PageHero
        variant="light"
        label="Technical Resource Library"
        title="Curated Technical Resources"
        intro="Manufacturer resources, technical guides and relevant industry references — organised around practical usefulness rather than simply collected as links."
        crumbs={[{ label: "Technical Hub", to: "/technical-hub" }, { label: "Resources" }]}
      />

      <section className="border-b border-brand-line bg-white">
        <div className="mx-auto max-w-7xl px-5 py-16 lg:px-8">
          <SectionLabel>Major Silicone Manufacturers</SectionLabel>
          <div className="grid gap-6 md:grid-cols-2">
            {SIL_RESOURCES.map((r) => (
              <div key={r.name} data-testid={`resource-${r.name.toLowerCase().replace(/\s+/g, "-")}`} className="flex flex-col border border-brand-line bg-white p-6">
                <div className="flex items-start justify-between gap-3">
                  <div>
                    <h3 className="font-heading text-lg font-bold text-brand-ink">{r.name}</h3>
                    <div className="text-xs text-brand-muted">{r.org}</div>
                  </div>
                  <span className="border border-brand-line bg-brand-bg px-2 py-1 font-mono text-[11px] text-brand-blue">
                    {r.tech}
                  </span>
                </div>
                <p className="mt-4 text-sm leading-relaxed text-brand-ink/85">{r.desc}</p>
                <dl className="mt-4 space-y-2 text-sm">
                  <div className="grid grid-cols-[110px_1fr] gap-2">
                    <dt className="text-brand-muted">Why useful</dt><dd className="text-brand-ink/80">{r.why}</dd>
                  </div>
                  <div className="grid grid-cols-[110px_1fr] gap-2">
                    <dt className="text-brand-muted">For</dt><dd className="text-brand-ink/80">{r.who}</dd>
                  </div>
                </dl>
                <div className="mt-4 flex items-center justify-between border-t border-brand-line pt-4">
                  <span className="text-xs text-brand-muted">Last reviewed: {r.reviewed}</span>
                  <a
                    href={r.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-1.5 text-sm font-semibold text-brand-blue hover:gap-2.5"
                  >
                    Official link <ExternalLink className="h-3.5 w-3.5" />
                  </a>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-10 border border-brand-line bg-brand-bg p-6 text-sm text-brand-muted">
            This library expands over time to include HCR, LSR and RTV guides, processing and
            compounding references, equipment, test methods, industry standards, regulatory
            information and academic resources.
          </div>
        </div>
      </section>

      <CTASection primary={{ to: "/technical-hub", label: "Back to Technical Hub" }} secondary={{ to: "/resources", label: "MATRIVON Toolkit" }} />
    </div>
  );
}
